export const WB_PREVIEW_PREFIX = '/wb-preview';

export function wbPath(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${WB_PREVIEW_PREFIX}${normalized}`;
}
